import { CcmSessionData } from '@fi-app/components/core-base';
import { FiSideListType } from './side-list-type';
import { FiApplicationLanguageType } from '@fi-shared/fi-content-language-shared/fi-application-language-type';
import { IContentLanguage } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';

export class SideListModel {
    SideListType: FiSideListType;
    Data: IContentLanguage[] = [];
    DataTextField = 'Name';
    DataValueField = 'Id';
    ActiveItem: any;
    DefaultItem: any;

    constructor(
        sideListType: FiSideListType,
        applicationLanguageType: FiApplicationLanguageType,
        preferredContentLanguage: number,
    ) {
        this.SideListType = sideListType;
        this.ActiveItem = preferredContentLanguage;
        this.DefaultItem = applicationLanguageType;
    }
}
